import { useCallback, useRef, useState } from 'react'
import isObject from 'lodash/isObject'
import isNumber from 'lodash/isNumber'
import constant from 'lodash/constant'
import get from 'lodash/get'
import { HEALTH_STATUS_MAINTENANCE } from '@klear/constants'
import { isUnauthorizedError, redirectToLogin } from '@klear/ui/lib/auth-redirect'

export function shouldProbeHealth(error: unknown): boolean {
  if (!isObject(error)) return false
  const status = get(error, 'data.httpStatus')
  if (status == null) return true
  return isNumber(status) && status >= 500
}

export async function probeMaintenance(healthUrl: string): Promise<boolean> {
  try {
    const res = await fetch(healthUrl, { credentials: 'include' })
    if (res.status === 503) return true
    if (!res.ok) return false
    const body = await res.json().catch(constant(null))
    return isObject(body) && get(body, 'status') === HEALTH_STATUS_MAINTENANCE
  } catch {
    return navigator.onLine
  }
}

export function useApiErrorHandler(healthUrl: string) {
  const [isMaintenance, setIsMaintenance] = useState(false)
  const probingRef = useRef(false)

  const onApiError = useCallback(
    (error: unknown) => {
      if (isUnauthorizedError(error)) {
        redirectToLogin()
        return
      }
      if (!shouldProbeHealth(error) || probingRef.current) return
      probingRef.current = true
      void probeMaintenance(healthUrl).then((down) => {
        probingRef.current = false
        if (down) setIsMaintenance(true)
      })
    },
    [healthUrl]
  )

  return { isMaintenance, onApiError }
}
